import {
    Row,
    Col,
    Container,
    Card,
    CardBody,
    Spinner,
    NavItem,
    Nav,
    TabContent,
    TabPane,
    NavLink
} from "reactstrap";
import OrgSearchTable from "../../components/OrgSearchTable/OrgSearchTable";
import OrgSearchTableUser from "../../components/OrgSearchTable/OrgSearchTableUser";
import DeviceGrid from "../../components/DeviceGrid/DeviceGrid";

import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import { useState, useEffect } from "react";
import { searchSubOrganizations, searchDevices, searchUsers, searchTopLevelOrganizations, getOrganization } from "../../utilities/orgPanelApiCalls";
import { useLocation } from "react-router-dom";
import { useStore } from "../../utilities/appStore";
import { ToastMessage } from '../../components/ToastMessage/ToastMessage.js';

const OrgSearchPanel = () => {
    let [users, setUsers] = useState([]);
    let [locations, setLocations] = useState([]);
    let [devices, setDevices] = useState([]);
    let [lastSearchTerm, setLastSearchTerm] = useState("");
    let [isLoading, setIsLoading] = useState(false);
    let [userIsAdmin, setUserIsAdmin] = useState(false);
    let [isAdminSearch, setIsAdminSearch] = useState(false);
    let [hTabsIcons, setHTabsIcons] = useState("organizationTab");
    let location = useLocation();
    const [toast, SetToast] = useState();

    let organization = useStore((state) => state.CurrentOrganization);
    let organizationId = useStore((state) => state.CurrentOrganizationId);
    let userRoles = useStore((state) => state.UserRoles);

    const makeToast = (message, type) => {
        SetToast({
            display: true,
            message: message,
            type: type
        });
    }
    const toastToggleCallback = () => {
        SetToast({
            display: false,
            message: ""
        });
    }

    useEffect(() => {
        async function loadRoles() {
            setIsLoading(true);
            if (userRoles.some(item => item.role === 3)) {
                setUserIsAdmin(true);
            }         

            setIsLoading(false);
        }
        loadRoles();

        if (location.state.searchFor !== null) {
            handleSearch();
        }

    }, [organizationId, userRoles]);

    let handleSearch = async () => {
        let term = "";
        if (location.state.searchFor !== null) {
            term = location.state.searchFor;
        }

        setIsLoading(true);
        var orgSearchResultPromise = null;

        if (location.state.searchAsAdmin) {
            //if user is admin, search the top level organizations.
            setIsAdminSearch(true);
            orgSearchResultPromise = searchTopLevelOrganizations(term)
            organizationId = 0;
        }
        else {
            orgSearchResultPromise = searchSubOrganizations(organizationId, term);

        }
        var userSearchResultPromise = searchUsers(organizationId, term);
        var deviceSearchResultPromise = searchDevices(organizationId, term);

        var userSearchResult = await userSearchResultPromise;
        var orgSearchResult = await orgSearchResultPromise;
        var deviceSearchResult = await deviceSearchResultPromise;

        if (orgSearchResult.status > 299 || userSearchResult.status > 299 || deviceSearchResult.status > 299) {
            console.error(`Unable to retrieve orgSearchResults: ${orgSearchResult}`);
            setLastSearchTerm('');
        }
        else {
            let data = orgSearchResult.data;
            setUsers(userSearchResult.data);
            setLocations(data);
            setLastSearchTerm(location.state.searchFor);
        }

        if (deviceSearchResult.status > 299) {
            console.error(`Unable to retrieve deviceSearchResults: ${deviceSearchResult}`);
            setLastSearchTerm('');

        }
        else {
            let devices = deviceSearchResult.data;
            setDevices(devices);
        }
        setHTabsIcons("locationTab");
        setIsLoading(false);
    };

    return (
        <>
            {toast?.display && (
                <ToastMessage Message={toast?.message} ToggleCallback={toastToggleCallback} Type={toast?.type} />
            )}
            <SimpleHeader name="Home" parentName="Search" />
            <Container className="mt--6" fluid>
                <Row className="justify-content-center">
                    <Col className="card-wrapper">
                        <Card className="search-card">
                            <CardBody>
                                <Container fluid>
                                    {!isLoading && lastSearchTerm &&
                                        <Row className="search-result-notification-row mb-1">
                                            <Col sm={12}>
                                                <h4>Search Results for "{lastSearchTerm}" in  {isAdminSearch ? "All Organizations" : organization.name}</h4>
                                            </Col>
                                        </Row>
                                    }
                                    <div className="search-nav-contents nav-wrapper">
                                        <Nav className="nav-fill flex-column flex-md-row" pills role="tablist">
                                       {/* Organization Masked pending review */}
                                            {/*<NavItem>*/}
                                            {/*    <NavLink*/}
                                            {/*        className={*/}
                                            {/*            "mb-sm-3 mb-md-0 " +*/}
                                            {/*            (hTabsIcons === "organizationTab" ? "active" : "")*/}
                                            {/*        }*/}
                                            {/*        onClick={(e) => {*/}
                                            {/*            e.preventDefault();*/}
                                            {/*            setHTabsIcons("organizationTab");*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        Organizations*/}
                                            {/*    </NavLink>*/}
                                            {/*</NavItem>*/}
                                            <NavItem>
                                                <NavLink
                                                    id="locations-tab"
                                                    className={
                                                        "mb-sm-3 mb-md-0 " +
                                                        (hTabsIcons === "locationTab" ? "active" : "")
                                                    }
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setHTabsIcons("locationTab");
                                                    }}
                                                >
                                                    Locations
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    id="devices-tab"
                                                    className={
                                                        "mb-sm-3 mb-md-0 " +
                                                        (hTabsIcons === "devicesTab" ? "active" : "")
                                                    }
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setHTabsIcons("devicesTab");
                                                    }}
                                                >
                                                    Devices & Subscriptions
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    id="users-tab"
                                                    className={
                                                        "mb-sm-3 mb-md-0 " +
                                                        (hTabsIcons === "userTab" ? "active" : "")
                                                    }
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setHTabsIcons("userTab");
                                                    }}
                                                >
                                                    Users
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                            </NavItem>
                                            <NavItem>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <Card className="search-results-card">
                                        <CardBody className="search-results-card">
                                            <TabContent id="tabContent" activeTab={hTabsIcons}>
                                                {/*<TabPane tabId="organizationTab" role="tabpanel">*/}
                                                {/* Organization Masked pending review */}
                                                {/*    <Row className="mb-1">*/}
                                                {/*        <h4>Under Construction</h4>*/}
                                                {/*    </Row>*/}
                                                {/*</TabPane>*/}
                                                <TabPane tabId="locationTab" role="tabpanel">
                                                    <Row className="mb-1">
                                                        <h4>Location</h4>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        {isLoading && <Spinner className="centered-loader" />}
                                                        {!isLoading && <OrgSearchTable data={locations} makeToast={makeToast} type="organization" refresh={handleSearch} />}
                                                    </Row>
                                                </TabPane>
                                                <TabPane tabId="devicesTab" role="tabpanel">
                                                    
                                                    <Row className="mb-1">
                                                        <h4>Devices</h4>
                                                    </Row>
                                                    <Row>
                                                        {isLoading && <Spinner className="centered-loader" />}
                                                        {!isLoading && <DeviceGrid data={devices} isLoading={isLoading} setIsLoading={setIsLoading} refreshDevices={handleSearch} />}
                                                    </Row>
                                                </TabPane>
                                                <TabPane tabId="userTab" role="tabpanel">
                                                    
                                                    <Row className="mb-1">
                                                        <h4>Users</h4>
                                                    </Row>
                                                    <Row className="mb-1">
                                                        {isLoading && <Spinner className="centered-loader" />}
                                                        {!isLoading && <OrgSearchTableUser data={users} type="user" />}
                                                    </Row>
                                                </TabPane>
                                            </TabContent>
                                        </CardBody>
                                    </Card>
                                </Container>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
};

export default OrgSearchPanel;